import {
  discover_feed_path,
  discover_feed_primary_feed_path,
  solution_listing_path,
} from "@routes/routes";
import {
  DiscoverFeedResponse,
  DiscoverFeedZodSchema,
  DiscoverSolutionListing,
} from "@tsTypes/discover_feed";
import request from "./request";

export interface SolutionListingResponse {
  solution_listing: DiscoverSolutionListing;
}

export const getDiscoverFeed = async (): Promise<DiscoverFeedResponse> => {
  const response = await request.get(discover_feed_primary_feed_path());
  return DiscoverFeedZodSchema.parse(response.data);
};

export const getDiscoverFeedById = async (id: number): Promise<DiscoverFeedResponse> => {
  const response = await request.get(discover_feed_path(id));
  return DiscoverFeedZodSchema.parse(response.data);
};

export const getSolutionListing = async (slug: string): Promise<SolutionListingResponse> => {
  const response = await request.get(solution_listing_path(slug));
  return response.data;
};
